/**
 * Every row in the table must have 7.2rem height as agreed with the design team,
 * so we multiply it by the page size to get the empty view height.
 * This will avoid the table from jumping between states.
 *
 * The extra 8.5rem is the footer size
 */
export var getFixedTableHeight = function getFixedTableHeight(pageSize) {
  return "".concat(7.2 * pageSize + 8.5, "rem");
};